'use client'

import React, { ComponentType } from 'react'
// import {
//   leaguesPath,
//   tournamentWithFiltersFiltersSchedulePath
// } from 'shared/urlHelpers'
import ListItem from 'components/ListItem'
import { TournamentsData } from 'data/tournaments'
import NewPagination from 'components/NewPagination'
import {
  leaguesPath,
  tournamentWithFiltersFiltersSchedulePath
} from 'shared/urlHelpers'
import { NewFilterArea } from 'components/filter/NewFilterArea'
import { SearchParams } from 'api/types'
// import { FilterArea } from 'components/filter/FilterArea'

interface Props {
  tournaments: TournamentsData
  searchParams: SearchParams
  season?: string | null
  phase?: string | null
}

const TournamentList: ComponentType<Props> = ({
  tournaments,
  searchParams,
  season,
  phase
}: Props) => (
  <>
    <NewFilterArea
      basePath={leaguesPath()}
      facets={tournaments.meta?.facets}
      totalCount={tournaments.meta?.totalCount}
      totalCountType="leagues"
    />
    <div className="view-vertical space-y-2 mt-3">
      {tournaments.data.map((t) => (
        <ListItem
          key={t.id}
          title={t.name}
          text={t.organization?.name}
          url={tournamentWithFiltersFiltersSchedulePath(t, {
            phase: phase,
            season: season
          })}
        />
      ))}
    </div>

    <NewPagination
      pathname={leaguesPath()}
      searchParams={searchParams}
      pagination={tournaments.meta}
    />
  </>
)

export default TournamentList
